import { setMwValue, getMwValue, setMwToken, getMwToken } from './utils';

// export const API_URL = 'http://luotottajaapisevice.azurewebsites.net/'

// export const API_URL = 'http://localhost:52974/';
// export const API_PROD_URL = 'http://localhost:52974/';

// export const API_URL = 'http://localhost:52974/';
 //export const API_URL = 'http://localhost:63107/';
 //export const API_PROD_URL = 'http://localhost:63107/';

// Production is the default. Local development can override via .env.local
// (REACT_APP_API_URL=http://localhost:3999/) so that all API calls hit the mock
// server in dev-mock/ instead of the real backend. The value is baked in at build time.
export const API_PROD_URL = 'https://api.kasvurahoitus.fi/';
export const API_URL = process.env.REACT_APP_API_URL || API_PROD_URL;

// export const API_PROD_URL = 'https://api.kasvurahoitus.fi/';
// export const API_URL = 'https://api.kasvurahoitus.fi/';

// Nets prod
export const TUPAS_URL = 'https://www.e-ident.nets.eu/its/index.html?';

// Nets test
//export const TUPAS_URL = 'https://www.ident-preprod1.nets.eu/its/index.html?';

// Signicat prod
//export const TUPAS_URL = 'https://vertaislaina.app.signicat.com/auth/open/connect/authorize?';

//const TUPAS_URL = API_URL+'api/Tupas/Providers';
const AUTH_URL = API_URL+'api/tokenauth?username=TEST&password=TEST123';
const CREATE_CUSTOMER_URL = API_URL+'api/customers';
const TUPAS_RESPONSE_URL = API_URL+'authenticated'
const GET_CUSTOMER_URL = API_URL+'api/customers';
const STORAGE_TOKEN_KEY = '_token';
const STORAGE_CUSTOMERID_KEY = '_customerId';

const AUTHENTICATION_SESSION_URL = API_URL+'api/Authorize/AuthenticationSession?id='
const INITIAL_APPLICATION_POST_URL = API_URL+'api/LoanApplications'
const INITIAL_REGISTRATION_POST_URL = API_URL+'api/Companies/RegisterCompany'

const APPLICATION_GET_URL = API_URL+'api/LoanApplications/'
const LOAN_WITH_APPLICATION_GET_URL = API_URL+'api/Loans/GetLoanByAppId?id='

const MYAPPLICATIONS_GET_URL = API_URL+'api/LoanApplications/MyApplications'
const MYLOANS_GET_URL = API_URL+'api/Loans/MyLoans'

const VALIDATEPHONE_POST_URL = API_URL+'api/LoanApplications/ValidatePhone'
const VALIDATEEMAIL_POST_URL = API_URL+'api/LoanApplications/ValidateEmail'
const VALIDATEPHONE_CODE_POST_URL = API_URL+'api/LoanApplications/ValidatePhoneCode'
const VALIDATEEMAIL_CODE_POST_URL = API_URL+'api/LoanApplications/ValidateEmailCode'

const REPAYMENTSBYCUSTOMERID_GET_URL = API_URL+'api/LoanPayments/GetRepaymentsByCustomer?id='
const CASHFLOWSBYCUSTOMERID_GET_URL = API_URL+'api/LoanPayments/GetCashflowsByCustomer?id='

const UPDATE_APPLICATIONSTATUS_POST_URL = API_URL+'api/LoanApplications/UpdateLoanApplicationStatus'
const UPDATE_LOANPARAMETERS_POST_URL = API_URL+'api/LoanApplications/UpdateLoanParameters'


const ALLAPPLICATIONS_GET_URL = API_URL+ 'api/LoanApplications/AllApplications'

const UPDATE_APPLICATIONDETAILS_POST_URL = API_URL+'api/LoanApplicationDetails'
const APPLICATIONDETAILS_GET_URL = API_URL+'api/LoanApplicationDetails/GetLoanApplicationDetailsByAppId?id='
const ASIAKASTIETORISKCLASS_GET_BYAPPID_URL = API_URL+'api/AsiakastietoRiskClasses/GetAsiakastietoRiskClassByAppId?id='

const GET_ASIAKASTIETOSCORINGDATA_URL = API_URL+'api/AsiakastietoRiskClasses/GetAsiakastietoScoringData?id='
const GET_APPROVEAPPLICATIONBYADMIN_URL = API_URL+'api/LoanApplications/ConfirmLoanApplicationByAdmin?id='
const GET_APPROVEAPPLICATIONBYBORROWER_URL = API_URL+'api/LoanApplications/ConfirmLoanApplicationByBorrower?id='
const GET_MARKDISBURSED_URL = API_URL+'api/LoanApplications/DisburseLoanApplication?id='
const GET_NEXTREPAYMENT_URL = API_URL+'api/LoanPayments/NextRepayment?id='
const SENDBORROWERAPPROVALREQUIREDMESSAGE_URL = API_URL+'api/LoanApplications/SendBorrowerApprovalRequiredMessage?id='

const UPDATE_APPLICATIONDESCRIPTION_POST_URL = API_URL+'api/LoanApplicationDescriptions'
const APPLICATIONDESCRIPTION_GET_URL = API_URL+'api/LoanApplicationDescriptions/GetLoanApplicationDescriptionByAppId?id='
const APPLICATION_ATTACHMENTS_POST_URL = API_URL+'api/LoanApplications/UploadAttachments'
const APPLICATION_ATTACHMENTS_GET_URL = API_URL+'api/LoanApplications/GetAttachments'
const APPLICATION_ATTACHMENTS_TEST_URL = API_URL+'api/LoanApplications/TestUploadRoute'

export const APPLICATION_UPDATE_DATA = 'APPLICATION_UPDATE_DATA'
export const APPLICATION_SAVING_DATA = 'APPLICATION_SAVING_DATA'
export const APPLICATION_SAVED_DATA_SUCCESS = 'APPLICATION_SAVED_DATA_SUCCESS'
export const APPLICATION_SAVED_DATA_ERROR = 'APPLICATION_SAVED_DATA_ERROR'

export const REGISTRATION_UPDATE_DATA = 'REGISTRATION_UPDATE_DATA'
export const REGISTRATION_SAVING_DATA = 'REGISTRATION_SAVING_DATA'
export const REGISTRATION_SAVED_DATA_SUCCESS = 'REGISTRATION_SAVED_DATA_SUCCESS'
export const REGISTRATION_SAVED_DATA_ERROR = 'REGISTRATION_SAVED_DATA_ERROR'

export const REQUEST_UPDATE_ADM_APPLICATION = 'REQUEST_UPDATE_ADM_APPLICATION'
export const RECEIVE_UPDATE_ADM_APPLICATION_SUCCESS = 'RECEIVE_UPDATE_ADM_APPLICATION_SUCCESS'

export const REQUEST_APPLICATION = 'REQUEST_APPLICATION'
export const RECEIVE_APPLICATION_SUCCESS = 'RECEIVE_APPLICATION_SUCCESS'
export const RECEIVE_APPLICATION_ERROR = 'RECEIVE_APPLICATION_ERROR'

export const REQUEST_LOAN = 'REQUEST_LOAN'
export const RECEIVE_LOAN_SUCCESS = 'RECEIVE_LOAN_SUCCESS'
export const RECEIVE_LOAN_ERROR = 'RECEIVE_LOAN_ERROR'

export const REQUEST_MYAPPLICATIONS = 'REQUEST_MYAPPLICATIONS'
export const RECEIVE_MYAPPLICATIONS_SUCCESS = 'RECEIVE_MYAPPLICATIONS_SUCCESS'
export const RECEIVE_MYAPPLICATIONS_ERROR = 'RECEIVE_MYAPPLICATIONS_ERROR'

export const REQUEST_ALLAPPLICATIONS = 'REQUEST_ALLAPPLICATIONS'
export const RECEIVE_ALLAPPLICATIONS_SUCCESS = 'RECEIVE_ALLAPPLICATIONS_SUCCESS'
export const RECEIVE_ALLAPPLICATIONS_ERROR = 'RECEIVE_ALLAPPLICATIONS_ERROR'

export const REQUEST_CONFIRMAPPLICATIONBYBORROWER = 'REQUEST_APPROVEAPPLICATIONBYBORROWER'
export const RECEIVE_CONFIRMAPPLICATIONBYBORROWER_SUCCESS = 'RECEIVE_APPROVEAPPLICATIONBYBORROWER_SUCCESS'
export const RECEIVE_CONFIRMAPPLICATIONBYBORROWER_ERROR = 'RECEIVE_APPROVEAPPLICATIONBYBORROWER_ERROR'

export const REQUEST_CONFIRMAPPLICATIONBYADMIN = 'REQUEST_APPROVEAPPLICATIONBYADMIN'
export const RECEIVE_CONFIRMAPPLICATIONBYADMIN_SUCCESS = 'RECEIVE_APPROVEAPPLICATIONBYADMIN_SUCCESS'
export const RECEIVE_CONFIRMAPPLICATIONBYADMIN_ERROR = 'RECEIVE_APPROVEAPPLICATIONBYADMIN_ERROR'

export const REQUEST_GETREPAYMENTSBYCUSTOMERID = 'REQUEST_GETREPAYMENTSBYCUSTOMERID'
export const RECEIVE_GETREPAYMENTSBYCUSTOMERID_SUCCESS = 'RECEIVE_GETREPAYMENTSBYCUSTOMERID_SUCCESS'
export const RECEIVE_GETREPAYMENTSBYCUSTOMERID_ERROR = 'RECEIVE_GETREPAYMENTSBYCUSTOMERID_ERROR'

export const REQUEST_GETCASHFLOWSBYCUSTOMERID = 'REQUEST_GETCASHFLOWSBYCUSTOMERID'
export const RECEIVE_GETCASHFLOWSBYCUSTOMERID_SUCCESS = 'RECEIVE_GETCASHFLOWSBYCUSTOMERID_SUCCESS'
export const RECEIVE_GETCASHFLOWSBYCUSTOMERID_ERROR = 'RECEIVE_GETCASHFLOWSBYCUSTOMERID_ERROR'

export const REQUEST_MARKLOANDISBURSED = 'REQUEST_MARKLOANDISBURSED'
export const RECEIVE_MARKLOANDISBURSED_SUCCESS = 'RECEIVE_MARKLOANDISBURSED_SUCCESS'
export const RECEIVE_MARKLOANDISBURSED_ERROR = 'RECEIVE_MARKLOANDISBURSED_ERROR'

export const REQUEST_GETNEXTREPAYMENT = 'REQUEST_GETNEXTREPAYMENT'
export const RECEIVE_GETNEXTREPAYMENT_SUCCESS = 'RECEIVE_GETNEXTREPAYMENT_SUCCESS'
export const RECEIVE_GETNEXTREPAYMENT_ERROR = 'RECEIVE_GETNEXTREPAYMENT_ERROR'

export const RECEIVE_SENDBORROWERAPPROVALCOMMUNICATION_SUCCESS = 'RECEIVE_SENDBORROWERAPPROVALCOMMUNICATION_SUCCESS'
export const REQUEST_SENDBORROWERAPPROVALCOMMUNICATION = 'REQUEST_SENDBORROWERAPPROVALCOMMUNICATION'

export const REQUEST_MYLOANS = 'REQUEST_MYLOANS'
export const RECEIVE_MYLOANS_SUCCESS = 'RECEIVE_MYLOANS_SUCCESS'
export const RECEIVE_MYLOANS_ERROR = 'RECEIVE_MYLOANS_ERROR'

export const REQUEST_UPDATE_APPLICATION_STATUS = 'REQUEST_UPDATE_APPLICATION_STATUS'
export const RECEIVE_UPDATE_APPLICATION_STATUS = 'RECEIVE_UPDATE_APPLICATION_STATUS'
export const RECEIVE_UPDATE_APPLICATION_STATUS_ERROR = 'RECEIVE_UPDATE_APPLICATION_STATUS_ERROR'

export const REQUEST_UPDATE_LOANPARAMETERS = 'REQUEST_UPDATE_LOANPARAMETERS'
export const RECEIVE_UPDATE_LOANPARAMETERS = 'RECEIVE_UPDATE_LOANPARAMETERS'
export const RECEIVE_UPDATE_LOANPARAMETERS_ERROR = 'RECEIVE_UPDATE_LOANPARAMETERS_ERROR'


export const REQUEST_VALIDATE_EMAIL = 'REQUEST_VALIDATE_EMAIL';
export const RECEIVE_VALIDATE_EMAIL = 'RECEIVE_VALIDATE_EMAIL';
export const RECEIVE_VALIDATE_EMAIL_ERROR = 'RECEIVE_VALIDATE_EMAIL_ERROR';

export const REQUEST_VALIDATE_PHONE = 'REQUEST_VALIDATE_PHONE';
export const RECEIVE_VALIDATE_PHONE = 'RECEIVE_VALIDATE_PHONE';
export const RECEIVE_VALIDATE_PHONE_ERROR = 'RECEIVE_VALIDATE_PHONE_ERROR';

export const REQUEST_ASIAKASTIETO = 'REQUEST_ASIAKASTIETO';
export const RECEIVE_ASIAKASTIETO = 'RECEIVE_ASIAKASTIETO';
export const RECEIVE_ASIAKASTIETO_ERROR = 'RECEIVE_ASIAKASTIETO_ERROR';

export const REQUEST_UPLOAD_ATTACHMENTS = 'REQUEST_UPLOAD_ATTACHMENTS';
export const RECEIVE_UPLOAD_ATTACHMENTS_SUCCESS = 'RECEIVE_UPLOAD_ATTACHMENTS_SUCCESS';
export const RECEIVE_UPLOAD_ATTACHMENTS_ERROR = 'RECEIVE_UPLOAD_ATTACHMENTS_ERROR';

export const REQUEST_GET_ATTACHMENTS = 'REQUEST_GET_ATTACHMENTS';
export const RECEIVE_GET_ATTACHMENTS_SUCCESS = 'RECEIVE_GET_ATTACHMENTS_SUCCESS';
export const RECEIVE_GET_ATTACHMENTS_ERROR = 'RECEIVE_GET_ATTACHMENTS_ERROR';


export const REQUEST_VALIDATE_EMAIL_CODE = 'REQUEST_VALIDATE_EMAIL_CODE';
export const RECEIVE_VALIDATE_EMAIL_CODE = 'RECEIVE_VALIDATE_EMAIL_CODE';
export const RECEIVE_VALIDATE_EMAIL_CODE_ERROR = 'RECEIVE_VALIDATE_EMAIL_CODE_ERROR';

export const REQUEST_VALIDATE_PHONE_CODE = 'REQUEST_VALIDATE_PHONE_CODE';
export const RECEIVE_VALIDATE_PHONE_CODE = 'RECEIVE_VALIDATE_PHONE_CODE';
export const RECEIVE_VALIDATE_PHONE_CODE_ERROR = 'RECEIVE_VALIDATE_PHONE_CODE_ERROR';

export const REQUEST_APPLICATION_DETAILS = 'REQUEST_APPLICATION_DETAILS'
export const RECEIVE_APPLICATION_DETAILS_SUCCESS = 'RECEIVE_APPLICATION_DETAILS_SUCCESS'
export const RECEIVE_APPLICATION_DETAILS_ERROR = 'RECEIVE_APPLICATION_DETAILS_ERROR'

export const REQUEST_APPLICATION_DESCRIPTION = 'REQUEST_APPLICATION_DESCRIPTION'
export const RECEIVE_APPLICATION_DESCRIPTION_SUCCESS = 'RECEIVE_APPLICATION_DESCRIPTION_SUCCESS'
export const RECEIVE_APPLICATION_DESCRIPTION_ERROR = 'RECEIVE_APPLICATION_DESCRIPTION_ERROR'


export function approveLoanApplicationByBorrower(applicationid) {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_CONFIRMAPPLICATIONBYBORROWER});        
         return fetch(GET_APPROVEAPPLICATIONBYBORROWER_URL+applicationid,             { headers: {           
            'authorization' : 'bearer '+token
        }                       
     }).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_CONFIRMAPPLICATIONBYBORROWER_SUCCESS, application: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function updateLoanApplicationDisbursed(applicationid) {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
     dispatch({type: REQUEST_UPDATE_ADM_APPLICATION, id:applicationid});        
         return fetch(GET_MARKDISBURSED_URL+applicationid,             { headers: {           
            'authorization' : 'bearer '+token
        }                       
     }).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_UPDATE_ADM_APPLICATION_SUCCESS, application: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}



export function getFetchApplicationDetails(applicationid) {
    return dispatch => {     
        dispatch({type: REQUEST_APPLICATION_DETAILS});        
         return fetch(APPLICATIONDETAILS_GET_URL+applicationid, {                        
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_APPLICATION_DETAILS_SUCCESS, application: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getAsiakastietoScoringData(applicationid) {
                return fetch(GET_ASIAKASTIETOSCORINGDATA_URL+applicationid);
}



export function getFetchLoanDetails(applicationid) {

    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_LOAN});        
         return fetch(LOAN_WITH_APPLICATION_GET_URL+applicationid, 
            { headers: {           
                    'authorization' : 'bearer '+token
                }                       
             }).then (  
            

            response =>             
                {
                    if (response.status == 404)
                        return;
                    return response.json(); }).then (
                    response => {     
                        if (response == undefined)
                            return;                     
                        return dispatch ({type : RECEIVE_LOAN_SUCCESS, data: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}





export function getFetchAsiakastietoByAppId(applicationid) {
    return dispatch => {     
        dispatch({type: REQUEST_ASIAKASTIETO});        
         return fetch(ASIAKASTIETORISKCLASS_GET_BYAPPID_URL+applicationid, {                        
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_ASIAKASTIETO, riskdata: response })
                    },                    
            error => {
                throw error;
            }) .catch(e => {
                // console.log('error getting asiakastieto', e);
            });
    }
}


export function getFetchApplicationDescription(applicationid) {
    return dispatch => {     
        dispatch({type: REQUEST_APPLICATION_DESCRIPTION});        
         return fetch(APPLICATIONDESCRIPTION_GET_URL+applicationid, {                        
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_APPLICATION_DESCRIPTION_SUCCESS, application: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}


export function getFetchGetBorrowalApprovalCommunication(applicationid) {
    return dispatch => {     
        dispatch({type: REQUEST_SENDBORROWERAPPROVALCOMMUNICATION});        
         return fetch(SENDBORROWERAPPROVALREQUIREDMESSAGE_URL+applicationid, {                        
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_SENDBORROWERAPPROVALCOMMUNICATION_SUCCESS, application: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function updateLoanParameters(application) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_UPDATE_LOANPARAMETERS});        
         return fetch(UPDATE_LOANPARAMETERS_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...application
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_UPDATE_LOANPARAMETERS, data: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function updateApplicationStatus(id, status) {
    return (dispatch, getState) => {        
        const token = getState().auth.token;  
        dispatch({type: REQUEST_UPDATE_APPLICATION_STATUS, data: id});        
         return fetch(UPDATE_APPLICATIONSTATUS_POST_URL, {
            method: 'POST',
            headers: {      
                'authorization' : 'bearer '+token,
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                loanApplicationId: id, 
                newStatus: status
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_UPDATE_APPLICATION_STATUS, data: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function createUpdateApplicant(application) {
    return (dispatch) => {
        dispatch({
            type: APPLICATION_UPDATE_DATA,
            application
        });     
    }
}
export function createUpdateRegistration(application) {
    return (dispatch) => {
        dispatch({
            type: REGISTRATION_UPDATE_DATA,
            application
        });     
    }
}



export function getFetchMyLoans ()  {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  

        dispatch({type: REQUEST_MYLOANS});        
         return fetch(MYLOANS_GET_URL, {                    
                headers: {           
                    'authorization' : 'bearer '+token
                }                                    
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_MYLOANS_SUCCESS, loans: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getFetchRepaymentsByCustomerId (id)  {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_GETREPAYMENTSBYCUSTOMERID});        
         return fetch(REPAYMENTSBYCUSTOMERID_GET_URL+id, { 
            headers: {           
                'authorization' : 'bearer '+token
            }                       
         }                       
         ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_GETREPAYMENTSBYCUSTOMERID_SUCCESS, repayments: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getFetchCashflowsByCustomerId (id)  {
    return (dispatch, getState) => {     
        const token = getState().auth.token;  
        dispatch({type: REQUEST_GETCASHFLOWSBYCUSTOMERID});        
         return fetch(CASHFLOWSBYCUSTOMERID_GET_URL+id, { 
            headers: {           
                'authorization' : 'bearer '+token
            }                       
         }                       
         ).then (  
            response => {
                 return response.json(); }).then (
                    response => {                          
                        return dispatch ({type : RECEIVE_GETCASHFLOWSBYCUSTOMERID_SUCCESS, cashflows: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}






export function getFetchMyApplications() {
    return (dispatch, getState) => {    
        const token = getState().auth.token;  
        dispatch({type: REQUEST_MYAPPLICATIONS});        
         return fetch(MYAPPLICATIONS_GET_URL, { 
            headers: {           
                'authorization' : 'bearer '+token
            }                       
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {                           
                        return dispatch ({type : RECEIVE_MYAPPLICATIONS_SUCCESS, application: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}

export function getFetchAllApplications() {
    return (dispatch, getState) => {    
        const token = getState().auth.token;  
        dispatch({type: REQUEST_ALLAPPLICATIONS});        
         return fetch(ALLAPPLICATIONS_GET_URL, { 
            headers: { 'authorization' : 'bearer '+token }                       
         }).then (  
            response => {
                 if (response.status == 401) 
                    return;                 
                 return response.json(); }).then (
                    response => {       
                        if (response == undefined)
                            return;                    
                        return dispatch ({type : RECEIVE_ALLAPPLICATIONS_SUCCESS, application: response })
                    },                    
            error => {
                throw error;
            }).catch();
    }
}

export function getValidateEmailWithCode(application) {
    return dispatch => {
        // console.log("sending email validation")
        // console.log(application);

        dispatch({type: REQUEST_VALIDATE_EMAIL_CODE});        
         return fetch(VALIDATEEMAIL_CODE_POST_URL, {
            method: 'POST',
            headers: {      
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...application
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_VALIDATE_EMAIL_CODE, data: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function getValidatePhoneWithCode(application) {
    return dispatch => {
        // console.log("sending phone validation")
        // console.log(application);

        dispatch({type: REQUEST_VALIDATE_PHONE_CODE});        
         return fetch(VALIDATEPHONE_CODE_POST_URL, {
            method: 'POST',
            headers: {      
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...application
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : RECEIVE_VALIDATE_PHONE_CODE, data: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function getValidateEmail(application) {
    return dispatch => {
        // console.log("sending email validation")
        // console.log(application);

        dispatch({type: REQUEST_VALIDATE_EMAIL});        
         return fetch(VALIDATEEMAIL_POST_URL, {
            method: 'POST',
            headers: {      
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...application
              }
            )
         }).then (  
            response => {
                        return dispatch ({type : RECEIVE_VALIDATE_EMAIL, data: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}

export function getValidatePhone(application) {
    return dispatch => {
        // console.log("sending phone validation")
        // console.log(application);
        dispatch({type: REQUEST_VALIDATE_PHONE});        
         return fetch(VALIDATEPHONE_POST_URL, {
            method: 'POST',
            headers: {      
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...application
              }
            )
         }).then (  
            response => {
                        return dispatch ({type : RECEIVE_VALIDATE_PHONE, data: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function getFetchApplication(applicationid) {

    return (dispatch, getState) => {     
        const token = getState().auth.token;  

        dispatch({type: REQUEST_APPLICATION});        
         return fetch(APPLICATION_GET_URL+applicationid, 
            { headers: {           
                    'authorization' : 'bearer '+token
                }                       
             }
        ).then (  
            response => {
                 return response.json(); }).then (
                    response => {  
                        dispatch({type : APPLICATION_UPDATE_DATA, application: response })   
                        return dispatch ({type : RECEIVE_APPLICATION_SUCCESS, application: response })
                    },                    
            error => {
                throw error;
            }) 
    }
}


export function uploadApplicationAttachments(applicationId, attachments) {
    return async (dispatch, getState) => {
        // Add persistent logging
        const addLog = (message) => {
            console.log(message);
            const logs = JSON.parse(localStorage.getItem('uploadLogs') || '[]');
            logs.push(`${new Date().toISOString()}: ${message}`);
            localStorage.setItem('uploadLogs', JSON.stringify(logs));
        };
        
        addLog("uploadApplicationAttachments called with applicationId: " + applicationId + ", attachments: " + attachments.length);
        
        if (!attachments || attachments.length === 0) {
            addLog("no attachments to upload, returning");
            return Promise.resolve(); // No attachments to upload
        }

        const token = getState().auth && getState().auth.token;
        addLog("token available: " + !!token);
        
        // Test the route first
        addLog("Testing upload route...");
        try {
            const headers = {};
            if (token) {
                headers['authorization'] = 'bearer ' + token;
            }
            
            const testResponse = await fetch(APPLICATION_ATTACHMENTS_TEST_URL, {
                method: 'GET',
                headers: headers
            });
            const testText = await testResponse.text();
            addLog("Test route response: " + testResponse.status + " " + testText);
        } catch (error) {
            addLog("Test route error: " + error.message);
        }
        
        dispatch({type: REQUEST_UPLOAD_ATTACHMENTS});
        
        const formData = new FormData();
        formData.append('applicationId', applicationId);
        
        attachments.forEach((attachment, index) => {
            addLog(`adding attachment ${index}: ${attachment.file.name}, description: ${attachment.description}`);
            formData.append('files', attachment.file);
            formData.append('descriptions', attachment.description || '');
        });

        addLog("sending request to: " + APPLICATION_ATTACHMENTS_POST_URL);
        addLog("formData contents:");
        for (let [key, value] of formData.entries()) {
            addLog(`${key}: ${value}`);
        }
        
        try {
            addLog("Sending POST request...");
            const headers = {};
            if (token) {
                headers['authorization'] = 'bearer ' + token;
            }
            
            const response = await fetch(APPLICATION_ATTACHMENTS_POST_URL, {
                method: 'POST',
                headers: headers,
                body: formData
            });
            
            addLog("attachment upload response status: " + response.status);
            
            if (!response.ok) {
                const text = await response.text();
                addLog("attachment upload error response: " + text);
                throw new Error(`HTTP error! status: ${response.status}, body: ${text}`);
            }
            
            const responseData = await response.json();
            addLog("attachment upload response data: " + JSON.stringify(responseData));
            dispatch({type: RECEIVE_UPLOAD_ATTACHMENTS_SUCCESS, data: responseData});
            return responseData;
        } catch (error) {
            addLog("attachment upload error: " + error.message);
            dispatch({type: RECEIVE_UPLOAD_ATTACHMENTS_ERROR, error: error});
            throw error;
        }
    }
}

export function getApplicationAttachments(applicationId) {
    return async (dispatch, getState) => {
        console.log("getApplicationAttachments called with applicationId:", applicationId);
        
        if (!applicationId) {
            console.log("No applicationId provided, returning");
            return Promise.resolve();
        }

        const token = getState().auth && getState().auth.token;
        console.log("Token available for attachments:", !!token);
        dispatch({type: REQUEST_GET_ATTACHMENTS});
        
        try {
            const headers = {};
            if (token) {
                headers['authorization'] = 'bearer ' + token;
            }
            
            const url = `${APPLICATION_ATTACHMENTS_GET_URL}?applicationId=${applicationId}`;
            console.log("Fetching attachments from URL:", url);
            
            const response = await fetch(url, {
                method: 'GET',
                headers: headers
            });
            
            console.log("Attachments response status:", response.status);
            
            if (!response.ok) {
                const errorText = await response.text();
                console.log("Attachments error response:", errorText);
                throw new Error(`HTTP error! status: ${response.status}, body: ${errorText}`);
            }
            
            const attachments = await response.json();
            console.log("Attachments received:", attachments);
            dispatch({type: RECEIVE_GET_ATTACHMENTS_SUCCESS, data: attachments});
            return attachments;
        } catch (error) {
            console.error("Error fetching attachments:", error);
            dispatch({type: RECEIVE_GET_ATTACHMENTS_ERROR, error: error});
            throw error;
        }
    }
}

export function createSaveApplication(application) {
    return async (dispatch) => {
        // Add persistent logging
        const addLog = (message) => {
            console.log(message);
            const logs = JSON.parse(localStorage.getItem('uploadLogs') || '[]');
            logs.push(`${new Date().toISOString()}: ${message}`);
            localStorage.setItem('uploadLogs', JSON.stringify(logs));
        };
        
        addLog("createSaveApplication called");
        
        // Separate attachments from application data
        const { attachments, ...applicationData } = application;
        
        addLog("separated attachments count: " + (attachments ? attachments.length : 0));
        addLog("application data prepared");
        
        console.log('=== POST TO BACKEND - Tracking Data ===');
        console.log('POST: affiliate =', applicationData.affiliate);
        console.log('POST: affiliateCode =', applicationData.affiliateCode);
        console.log('POST: affiliateBrowserId =', applicationData.affiliateBrowserId);
        console.log('POST: ga4ClientId =', applicationData.ga4ClientId);
        console.log('POST: ga4SessionId =', applicationData.ga4SessionId);
        console.log('=== END POST DATA ===');
        
        dispatch(createUpdateApplicant(application));
        dispatch({type: APPLICATION_SAVING_DATA});
        
        try {
            const response = await fetch(INITIAL_APPLICATION_POST_URL, {
                method: 'POST',
                headers: {      
                    'Content-Type': 'application/json;charset=utf-8'
                },
                body: JSON.stringify({...applicationData})
            });
            
            // Do not treat an error JSON body as a saved application (H2 / investigation 5.10.2026).
            if (!response.ok) {
                let bodyText = '';
                try {
                    bodyText = await response.text();
                } catch (e) {
                    bodyText = '';
                }
                addLog("application save failed HTTP " + response.status + ": " + bodyText);
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const responseData = await response.json();
            addLog("application save response received, id: " + responseData.id);
            dispatch({type : APPLICATION_SAVED_DATA_SUCCESS, data: responseData });
            
            // Upload attachments if they exist and we have an application ID
            if (attachments && attachments.length > 0 && responseData.id) {
                addLog("uploading attachments for application ID: " + responseData.id);
                await dispatch(uploadApplicationAttachments(responseData.id, attachments));
                addLog("attachments upload completed successfully");
            } else {
                addLog("no attachments to upload. attachments: " + (attachments ? attachments.length : 0) + ", response.id: " + responseData.id);
            }
            
            return responseData;
        } catch (error) {
            addLog("error saving application: " + error.message);
            dispatch({type: APPLICATION_SAVED_DATA_ERROR, error: error});
            throw error;
        }
    }
}

export function createSaveRegistration(application) {
    return dispatch => {
        // console.log("sending new")
        // console.log(application);
        dispatch(createUpdateRegistration(application));
        dispatch({type: REGISTRATION_SAVING_DATA});
        
         return fetch(INITIAL_REGISTRATION_POST_URL, {
            method: 'POST',
            headers: {      
                'Content-Type': 'application/json;charset=utf-8'
              },
            body: JSON.stringify({
                ...application
              }
            )
         }).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : REGISTRATION_SAVED_DATA_SUCCESS, data: response })
                    },                    
            error => {
                throw error;
            }                                
                 )  
    }
}


export function GetAuthenticationSession(sessionId) {
    return dispatch => {
        // console.log("getting authentication session")
        // console.log(sessionId);

         return fetch(AUTHENTICATION_SESSION_URL + sessionId).then (  
            response => {
                 return response.json(); }).then (
                    response => {     
                        return dispatch ({type : 'AUTHENTICATION_SUCCESS', data: response })
                    },                    
            error => {
                throw error;
            }                                
        )}   
}

export function ytjSuccess(json) {
  console.log('ytjSuccess called with data:', json);
  return {
    type: 'YTJ_SUCCESS',
    data: json
  }
}

export function ytjFailure(err) {
    return {
      type: 'YTJ_FAILURE',
      data: err
    }
  }

export function getYtjInformation(bic) {
    
    console.log('getYtj called with bic:', bic);
    let ytjUrl = 'https://avoindata.prh.fi/opendata-ytj-api/v3/companies?businessId='+bic;
    
    return (dispatch) => {
        dispatch(createUpdateApplicant({bic: bic}));
        console.log('Starting YTJ fetch...');
        
        return fetch(ytjUrl)
        .then(response => {
            console.log('YTJ response status:', response.status);
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(response => {
            console.log('YTJ response data:', response);
            console.log('Dispatching ytjSuccess...');
            return dispatch(ytjSuccess(response));
        })
        .catch(error => {
            console.error('YTJ fetch error:', error);
            return dispatch(ytjFailure(error));
        });
    }
}

// export function getYtjInformation(bic) {

//     let ytjUrl = "https://avoindata.prh.fi/bis/v1?totalResults=false&maxResults=5&resultsFrom=0&businessId="+bic;
//     return (dispatch) => {
      
//         return fetch(ytjUrl, {
//             method: 'GET',
            
//         }).then (
//             response => {
//                 return response.json() }).then (
//                     response => {
//                         return dispatch ({ type: 'YTJ_SUCCESS', data: response})
//                     }
//                 )
//             }
// }
  


  

